// extracted by mini-css-extract-plugin
module.exports = {"container":"FormFooter_container__33Yfg","message":"FormFooter_message__19EXG","navigation_link":"FormFooter_navigation_link__1j1OU"};